import React, { useEffect, useState, useMemo } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    TrendingUp,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import PaletteIcon from "@material-ui/icons/Palette";
import { useErrorHandler } from "../../../hooks";

import mainPageService from "../../../services/main-page.service";
import SliderTable from "./SliderTable";
import ChangeSort from "./changeSort";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function MainPagePage() {

    const errorHandler = useErrorHandler();

    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        const res = await mainPageService.deleteMainPage(item.id);
        if (res.error) {
            const error = res.error.response.data.error;
            errorHandler(error);
        }
    };

    const headerCells = useMemo(
        () => [
            {
                field: "index",
                title: "ردیف",
                mainField: true,
            },
            {
                field: "title",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "type",
                title: "نوع",
                mainField: true,
            },
            {
                field: "image",
                title: "عکس",
                renderer: (val) =>
                    val ? <img className="main-page-img" src={val} alt="" /> : "-",
            },
        ],
        []
    );

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await mainPageService.getMainPage();
        if (error) {
            // handleError(error);
            return;
        }

        const sliders = data.filter(item => item.type === 'slide');
        const notSliders = data
            .filter(item => item.type !== 'slide')
            .map(item => {
                let otherInfo = {};
                if (item.otherInfo && typeof item.otherInfo === "string") {
                    otherInfo = JSON.parse(item.otherInfo)
                }
                return {
                    ...item,
                    index: item.sort + 1,
                    ...otherInfo
                }
            })
            .sort((a, b) => a.index - b.index)

        let rows = [{
            index: 0,
            image: "",
            title: "اسلایدر",
            type: "slider",
            sliders
        }, ...notSliders]


        setData(rows);
    };

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                order={{ order: "ASC", orderBy: "index" }}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <PaletteIcon />,
                        modalProps: { fullScreen: true },
                        hidden: (data) => data.type !== "slider",
                        modalContent: (props) => <SliderTable {...props} onRefresh={onRefresh} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        hidden: (data) => data.type === "slider",
                        modalContent: (props) => <FormModalContent {...props} hasMoreButton={true} type="fullCard" />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <TrendingUp />,
                        hidden: (data) => data.type === "slider",
                        modalContent: (props) => <ChangeSort {...props} allData={data.filter(item => item.type !== "slider")}/>,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        hidden: (data) => data.type === "slider",
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد ردیف",
                        modalContent: (props) => <FormModalContent {...props} hasMoreButton={true} type="fullCard" />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="صفحه ای خانه"
            />
        </div>
    );
}
